import { render, staticRenderFns } from "./CenterInquiryPage.vue?vue&type=template&id=7625870a&"
import script from "./CenterInquiryPage.vue?vue&type=script&lang=js&"
export * from "./CenterInquiryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports